import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToplineRoutingModule } from './topline-routing.module';
import { ToplineComponent } from './topline.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { SharedRepositoryModule } from '../shared-repository/shared-repository.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ExcelViewerComponent } from '../repository/excel-viewer/excel-viewer.component';
import { TableViewComponent } from '../repository/excel-viewer/table-view/table-view.component';
import { EditSheetComponent } from '../repository/excel-viewer/edit-sheet/edit-sheet.component';
import { GroupTableComponent } from '../repository/excel-viewer/group-table/group-table.component';
import { EditGroupComponent } from '../repository/excel-viewer/edit-group/edit-group.component';
import { DownloadSettingComponent } from '../repository/excel-viewer/download-setting/download-setting.component';
import { DataSourceComponent } from '../repository/excel-viewer/data-source/data-source.component';
import { MergeToplineComponent } from '../repository/excel-viewer/merge-topline/merge-topline.component';
import { KpiReorderComponent } from '../repository/excel-viewer/table-view/kpi-reorder/kpi-reorder.component';
import { ExpandMode, NgxTreeSelectModule } from 'src/ngx-tree-select/src';
import { KpigridComponent } from '../repository/excel-viewer/table-view/kpigrid/kpigrid.component';
import { AgGridModule } from 'ag-grid-angular';
import { ChildkpiReorderComponent } from '../repository/excel-viewer/table-view/kpi-reorder/childkpi-reorder/childkpi-reorder.component';


@NgModule({
  declarations: [
    ToplineComponent,
    ExcelViewerComponent,
    TableViewComponent,
    EditSheetComponent,
    GroupTableComponent,
    EditGroupComponent,
    DownloadSettingComponent,
    DataSourceComponent,
    MergeToplineComponent,
    KpiReorderComponent,
    ChildkpiReorderComponent,
    KpigridComponent
  ],
  imports: [
    CommonModule,
    ToplineRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    SharedRepositoryModule,
    InfiniteScrollModule,
    AgGridModule.withComponents([]),
    NgxTreeSelectModule.forRoot({
      idField: 'id',
      textField: 'name',
      expandMode: ExpandMode.Selection,
    }),
  ]
})
export class ToplineModule { }
